import { render } from "./SelectedChat.vue?vue&type=template&id=8c80ea64&scoped=true"
import script from "./SelectedChat.vue?vue&type=script&lang=js"
export * from "./SelectedChat.vue?vue&type=script&lang=js"

import "./SelectedChat.vue?vue&type=style&index=0&id=8c80ea64&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c80ea64"]])

export default __exports__